import React, { useState } from 'react';
import {
    Card, CardBody, CardTitle, Col, Container, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input
} from 'reactstrap';

const Download = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [downloadLink, setDownloadLink] = useState('');

    const toggleModal = (link = '') => {
        setModalOpen(!modalOpen);
        setPhoneNumber('');
        setDownloadLink(link);
    };

    const handleDownload = () => {
        if (phoneNumber.trim().length < 10) {
            alert("Please enter a valid phone number");
            return;
        }

        const link = document.createElement('a');
        link.href = downloadLink;
        link.download = downloadLink.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
            toggleModal();
        }, 1000);
    };

    return (
        <div className="page-content" style={{ color: "#fff", fontFamily: "'Roboto', sans-serif" }}>
            <Container fluid={true} className="py-1">
                <Row className="justify-content-center">
                    <Col xl={8} lg={8} md={10}>
                        <Card style={{
                            background: "rgba(255, 255, 255, 0.1)",
                            border: "none",
                            borderRadius: "15px",
                            padding: "20px"
                        }}>
                            <CardBody className="d-flex flex-column align-items-start">
                                <CardTitle className="mb-4 text-center w-100" style={{ fontSize: "1.8rem", fontWeight: "600" }}>
                                    AI Data Driven Pre Preparation Checklist to Buy/Sell/Rent Property Downloads
                                </CardTitle>

                                {/* Residential */}
                                <h5 className="mb-3" style={{ fontWeight: 600 }}>🏡 Residential</h5>
                                <Button
                                    className="mb-3"
                                    onClick={() => toggleModal('/downloads/pre-purchase-residential.pdf')}
                                    style={{
                                        background: "linear-gradient(135deg, #6f42c1, #0d6efd)",
                                        color: "white",
                                        border: "none",
                                        padding: "10px 16px",
                                        fontWeight: "500",
                                        borderRadius: "8px",
                                        transition: "all 0.3s ease-in-out"
                                    }}
                                >
                                    Download Pre Purchase Checklist – Residential
                                </Button>
                                <Button
                                    className="mb-4"
                                    onClick={() => toggleModal('/downloads/pre-rent-residential.pdf')}
                                    style={{
                                        background: "linear-gradient(135deg, #6f42c1, #0d6efd)",
                                        color: "white",
                                        border: "none",
                                        padding: "10px 16px",
                                        fontWeight: "500",
                                        borderRadius: "8px",
                                        transition: "all 0.3s ease-in-out"
                                    }}
                                >
                                    Download Pre Rent Checklist – Residential (For Tenants)
                                </Button>

                                {/* Commercial */}
                                <h5 className="mb-3 mt-3" style={{ fontWeight: 600 }}>🏢 Commercial</h5>
                                <Button
                                    onClick={() => toggleModal('/downloads/pre-purchase-commercial.pdf')}
                                    style={{
                                        background: "linear-gradient(135deg, #6f42c1, #0d6efd)",
                                        color: "white",
                                        border: "none",
                                        padding: "10px 16px",
                                        fontWeight: "500",
                                        borderRadius: "8px",
                                        transition: "all 0.3s ease-in-out"
                                    }}
                                >
                                    Download Pre Purchase Checklist – Commercial
                                </Button>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>


            {/* Modal */}
            <Modal isOpen={modalOpen} toggle={toggleModal} centered backdrop="static">
                <div style={{
                    background: '#1e1e2f',
                    padding: '25px',
                    borderRadius: '20px',
                    color: '#fff',
                    boxShadow: '0 0 20px rgba(0, 255, 213, 0.3)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    fontFamily: "'Poppins', sans-serif"
                }}>
                    <ModalHeader
                        toggle={toggleModal}
                        style={{
                            borderBottom: '1px solid rgba(255,255,255,0.1)',
                            fontSize: '1.4rem',
                            fontWeight: '600',
                            color: '#00ffd5'
                        }}
                    >
                        🔒 Secure Download
                    </ModalHeader>

                    <ModalBody>
                        <Input
                            type="tel"
                            placeholder="Enter Phone no. to Download The File"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            style={{
                                backgroundColor: '#2d2d44',
                                border: '1px solid #3e3e5e',
                                borderRadius: '12px',
                                padding: '14px',
                                color: '#fff',
                                fontSize: '1rem',
                                boxShadow: '0 0 5px rgba(0, 255, 213, 0.3)'
                            }}
                        />
                    </ModalBody>

                    <ModalFooter style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
                        <Button
                            onClick={handleDownload}
                            style={{
                                background: 'linear-gradient(135deg, #00ffd5, #5f72be)',
                                border: 'none',
                                color: '#000',
                                padding: '10px 24px',
                                borderRadius: '14px',
                                fontWeight: '600',
                                boxShadow: '0 0 10px rgba(0, 255, 213, 0.5)',
                            }}
                        >
                            📥 Download
                        </Button>
                        <Button
                            onClick={toggleModal}
                            style={{
                                background: '#2d2d44',
                                border: '1px solid #3e3e5e',
                                color: '#fff',
                                padding: '10px 20px',
                                borderRadius: '14px',
                                fontWeight: '500'
                            }}
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </div>
            </Modal>

        </div>
    );
};

export default Download;
